import { MarkdownView } from './MarkdownView';
import styles from './ReadAloud.module.css';

export interface ReadAloudProps {
  children: string;
  label?: string;
}

/** Boxed "read-aloud" text on a parchment background, for GM narration. */
export function ReadAloud({ children, label = 'Da leggere' }: ReadAloudProps) {
  return (
    <div className={styles.readAloud}>
      <span className={styles.label}>{label}</span>
      <MarkdownView>{children}</MarkdownView>
    </div>
  );
}
